/** En dev sans VITE_API_URL : chaîne vide → URLs relatives `/api/...` via le proxy Vite (évite d’appeler le port du frontend et de recevoir du HTML). */
export const API_URL =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV ? '' : '');

export const APP_CONFIG = {
  title: 'Réparation iPhone et informatique à Viry – SOS IT Services',
  /** Fichier statique dans `public/` — évite les data URLs (CSP / onglet avant hydratation). */
  favicon: '/icons/favicon-48.png',
  routes: {
    home: '/',
    depannage: '/depannage-informatique',
    reparationTelephone: '/reparation-telephone',
    reparationTelephoneTarifs: '/reparation-telephone/tarifs',
    creationSite: '/creation-site-web',
    monEspace: '/mon-espace',
    tickets: '/tickets/:id',
    expertsMap: '/experts-map',
    politiqueConfidentialite: '/politique-de-confidentialite',
    mentionsLegales: '/mentions-legales',
    conditionsUtilisation: '/conditions-utilisation',
    blog: '/blog',
    blogSilo: '/blog/silo/:siloId',
    blogArticle: '/blog/:slug',
    depannageGenevois: '/depannage-informatique-region-geneve',
    depannageSaintJulien: '/depannage-informatique-saint-julien-en-genevois',
    depannageAnnemasse: '/depannage-informatique-annemasse',
    depannageAnnecy: '/depannage-informatique-annecy',
    depannageGex: '/depannage-informatique-gex',
    depannageViry: '/depannage-informatique-viry',
    depannageValleiry: '/depannage-informatique-valleiry',
    depannageSaintGenis: '/depannage-informatique-saint-genis-pouilly',
    depannageFerney: '/depannage-informatique-ferney-voltaire',
    depannageDivonne: '/depannage-informatique-divonne-les-bains',
    depannagePrevessin: '/depannage-informatique-prevessin-moens',
    depannageArchamps: '/depannage-informatique-archamps',
    depannageCollonges: '/depannage-informatique-collonges-sous-saleve',
    depannageOrnex: '/depannage-informatique-ornex',
    depannageCessy: '/depannage-informatique-cessy',
    depannageSegny: '/depannage-informatique-segny',
    depannageGeneve: '/depannage-informatique-geneve',
    reparationTelephoneViry: '/reparation-telephone-viry',
    reparationTelephoneSaintJulien: '/reparation-telephone-saint-julien-en-genevois',
    reparationIphoneGeneve: '/reparation-iphone-geneve',
    reparationTelephoneAnnemasse: '/reparation-telephone-annemasse',
    creationSiteAnnemasse: '/creation-site-internet-annemasse',
    creationSiteSaintJulien: '/creation-site-internet-saint-julien-en-genevois',
    creationSitePaysDeGex: '/creation-site-internet-pays-de-gex',
    creationSiteAnnecy: '/creation-site-internet-annecy',
    contact: '/contact',
  },
  contact: {
    phoneDisplay: '06 26 74 82 99',
    phoneTel: '+33626748299',
    whatsappNumber: '33626748299',
    whatsappUrl: 'https://wa.me/33626748299',
  },
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  // Map ID nécessaire pour Google Advanced Markers (AdvancedMarkerElement)
  googleMapsMapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || '',
}; 